import React, {useRef} from 'react'
import SubHeader from '../general/SubHeader'
import axios from 'axios';
import emailjs from '@emailjs/browser';


const Careers = () => {

    const form = useRef();

    const sendEmail = async (e) => {
      e.preventDefault();
    
      const formData = new FormData(form.current);
      const resumeFile = formData.get('user_resume');
    
      try {
        // upload resume to server
        // const resumeBase64 = await convertFileToBase64(resumeFile);
        // formData.append('user_resume_base64', resumeBase64);
        // formData.append('user_resume_filename', resumeFile.name);
        const formDataToSend = new FormData();
        formDataToSend.append('resume', resumeFile);
    
        const uploadResponse = await axios.post('http://localhost:3001/api/career', formDataToSend, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
    
        const resumeUrl = uploadResponse.data.fileUrl;
    
        // send form data
        const emailData = {
          user_name: formData.get('user_name'),
          user_email: formData.get('user_email'),
          user_mobile: formData.get('user_mobile'),
          user_role: formData.get('user_role'),
          user_resume_url: resumeUrl,
          message: formData.get('message'),
        };
    
        await emailjs.send('dectwin_career', 'template_1career', emailData, {
          publicKey: 'D9hdOe6X3U62d5Q-6',
        });
    
            alert('Form Submission Successful');
            form.current.reset();    
      }
      catch(error){
            console.log('FAILED...', error);
          }
    };
    

  return (
    <>
      <SubHeader message='Careers' />

      {/* Careers Section */}
      <section animateIn='fadeInUp' className='my-5'>
        <div className='container'>

        <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Careers at Dectwin</p>
                    <p className='sec-heading my-0'>Be A Part of Our Team</p>
          <p>Fill out the form below and send your details to us. Our team will connect shortly.</p>


          <form className="row g-3 my-4" ref={form} onSubmit={sendEmail} encType='multipart/form-data'>
            <div className="col-12">
              <input type="text" className="support-input" id="inputText4" placeholder='Your Name' name='user_name' required />
            </div>

            <div className="col-md-6">
              <input type="email" className="support-input" id="inputEmail4" placeholder='Your Email' name='user_email' required />
            </div>

            <div className="col-md-6">
              <input type="tel" className="support-input" id="inputNumber4" placeholder='Mobile Number' name='user_mobile' required />
            </div>

            <div className="col-md-6">
              <select className="support-input" name='user_role' required>
                <option className="support-input" value="" selected disabled>Role Applying for</option>
                <option className="support-input" value="Software Developer">Software Developer</option>
                <option className="support-input" value="Web Developer">Web Developer</option>
                <option className="support-input" value="Graphic Designer">Graphic Designer</option>
                <option className="support-input" value="Sales & Marketing">Sales & Marketing</option>
              </select>

              {/* <input type="text" className="support-input" id="inputText4" placeholder='Role Applying for' name='' required /> */}
            </div>

            <div className="col-md-6">
              <input type="file" className="support-input" id="inputGroupFile" placeholder='Attach resume here' name='user_resume' required />
            </div>

            <div className="col-12">
              <textarea type="text" className="support-input" id="inputText" placeholder="Describe your skills here.." style={{ height: '8em' }} name='message' required></textarea>
            </div>

            <div className="col-12">
              <button type="submit" className="header-btn w-100">Submit Now</button>
            </div>
          </form>
          {/* form ends */}


        </div>
      </section>
      {/* Careers Section Ends */}


    </>
  )
}

export default Careers
